// Layout.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCurrentUser } from "store/auth/thunks";
import { getToken } from "helpers/tokenHelpers";
import { useSelector } from "react-redux";
import { fetchFavorites } from "store/favorites/thunks";
import { useLanguage } from "context";

const UserDataLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { userType } = useSelector((state) => state.auth);
  const { language } = useLanguage();
  const accessToken = useSelector((state) => state.auth.token);

  useEffect(() => {
    console.log("accessToken", accessToken);
    dispatch(fetchFavorites(accessToken, userType));
    if (accessToken) {
      dispatch(getCurrentUser({language: language})); // Dispatch getCurrentUser
    }
  }, [accessToken]);

  return <>{children}</>;
};

export default UserDataLayout;
